import type { InventoryResource } from '@repo/api-gw-sdk';

const sqlServerAppName = 'Microsoft SQL Server';

export const sqlServerVersionLabel = (
  entity: InventoryResource
): string | undefined => {
  const version = entity.classifications?.appsDetails?.apps?.find(
    (app) => app.name === sqlServerAppName
  )?.version;

  return version ? `SQL Server ${version}` : undefined;
};
